export default {
    data() {
        return {

        }
    },
    methods: {
        /** 预览/查看态：表单只读（列表预览、详情查看进入） */
        isPreviewMode() {
            return (
                this.$route?.query?.new === "preview" ||
                this.$parent?.news === "preview" ||
                this.$parent?.editInfo?.type === "preview" ||
                this.oldInfos?.type === "preview" ||
                this.oldInfo?.type === "preview" ||
                this.info?.type === "preview"
            );
        },
        /** 若为预览态则锁定 isEdit，返回是否已锁定 */
        lockIfPreview() {
            if (this.isPreviewMode()) {
                this.isEdit = true;
                return true;
            }
            return false;
        },
        pickFieldRaw(obj, field) {
            if (!obj) return "";
            const dictText = obj[field + "_dictText"];
            const raw = obj[field];
            const val =
                raw !== null && raw !== undefined && raw !== ""
                    ? raw
                    : dictText !== null && dictText !== undefined && dictText !== ""
                    ? dictText
                    : "";
            return val === null || val === undefined || val === "" ? "" : String(val);
        },
        pickDiffValue(obj, field) {
            let val = this.pickFieldRaw(obj, field);
            // 思政微课团队「学历」落在 education，旧对比配置误用 degree
            if (!val && (field === "education" || field === "degree")) {
                val = this.pickFieldRaw(obj, field === "education" ? "degree" : "education");
            }
            return val;
        },
        parseDiffObj(val) {
            if (!val) return {};
            if (typeof val === "object") return val;
            try {
                return JSON.parse(val);
            } catch (e) {
                return {};
            }
        },
        /** 新增记录悬停：用当前模块 FIELD_LABELS 列出字段，不套其它类型字段名 */
        insertDiff(record) {
            const after =
                record && (record.nowTransContent || record.nowContent);
            if (after) return this.diff("{}", after);
            return this.diff("{}", record || {});
        },
        insertDiffs(record) {
            const after =
                record && (record.nowTransContent || record.nowContent);
            if (after) return this.diffs("{}", after);
            return this.diffs("{}", record || {});
        },
        diff(obj1, obj2) {
            if (!obj1 || !obj2) {
                return [];
            } else {
                const fields = Object.keys(this.fieldLabels || {});
                let sj = this.parseDiffObj(obj1);
                let sjs = this.parseDiffObj(obj2);
                const differences = [];
                fields.forEach((field) => {
                    const v1 = this.pickDiffValue(sj, field);
                    const v2 = this.pickDiffValue(sjs, field);
                    if (v1 !== v2) {
                        differences.push({
                            field: this.fieldLabels[field],
                            obj1: v1,
                            obj2: v2,
                            key: field,
                        });
                    }
                });

                // console.log(differences, "4444");
                return differences;
            }
        },
        diffs(obj1, obj2) {
            console.log('88888')
            if (!obj1 || !obj2) {
                return [];
            } else {
                const fields = Object.keys(this.fieldLabelss || {});
                let sj = this.parseDiffObj(obj1);
                let sjs = this.parseDiffObj(obj2);
                const differences = [];
                const normalizeEmpty = (val) =>
                    val === null || val === undefined || val === "" ? "" : val;
                // 遍历字段，找出不同的值
                fields.forEach((field) => {
                    const v1 = normalizeEmpty(sj[field]);
                    const v2 = normalizeEmpty(sjs[field]);
                    if (v1 !== v2) {
                        differences.push({
                            field: this.fieldLabelss[field], // 显示中文字段名
                            obj1: sj[field],
                            obj2: sjs[field],
                        });
                    }
                });

                // console.log(differences, "4444");
                return differences;
            }
        },
    }
}